export const fetchAirports = async () => {
  const res = await fetch("https://online.funforay.com/admin/api/airports");
  const data = await res.json();
  return data.map(item => ({
    value: item.airportcode || 'XXX',
    label: `${item.cityname || 'Unknown'} - ${item.airportcode || 'XXX'} - ${item.airportname || 'Unknown Airport'}`,
    cityname: item.cityname || 'Unknown',
    airportcode: item.airportcode || 'XXX',
    airportname: item.airportname || 'Unknown Airport'
  }));
};

export const fetchPackages = async () => {
  const res = await fetch("https://online.funforay.com/admin/api/packages");
  const response = await res.json();
  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  } else {
    throw new Error("Unexpected package format");
  }
};

// Change from fetchCities to fetchCountries
export const fetchCountries = async () => {
  try {
    const res = await fetch("https://online.funforay.com/admin/api/cities/"); // Keep the endpoint if it returns the whole table
    const data = await res.json();
    
    // Extract unique country names from the 'country' column
    const countries = [...new Set(data.map(item => item.country))];
    return countries;
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};

export const fetchHotels = async () => {
  const res = await fetch("https://online.funforay.com/admin/api/hotels");
  if (!res.ok) {
    throw new Error("Failed to fetch hotels");
  }
  const hotels = await res.json();
  return Array.isArray(hotels) ? hotels : [];
};




// ✅ Fetch Hotel Cities
export const fetchHotelCities = async (countryCode = "IN") => {
  try {
    const res = await fetch(`https://online.funforay.com/admin/api/hotels/cities?countryCode=${countryCode}`, {
      method: "GET",
      headers: { Accept: "application/json" }
    });

    const data = await res.json();
    console.log("📌 Hotel Cities API Response:", data);

    return Array.isArray(data?.CityList)
      ? data.CityList.map(city => ({
          code: city.Code || "",
          name: city.Name || "",
        }))
      : [];
  } catch (error) {
    console.error("❌ Error fetching hotel cities:", error);
    return [];
  }
};

// ✅ Fetch Hotels by City
export const fetchHotelsByCity = async (cityCode) => {
  if (!cityCode) return [];

  try {
    const res = await fetch(`https://online.funforay.com/admin/api/hotels-city/get-hotels`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ cityCode })
    });

    // Parse JSON safely
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (parseError) {
      console.error("❌ Failed to parse JSON. Response text:", text);
      return [];
    }

    console.log("🏨 Hotels API Response:", data);

    if (data?.error) {
      console.error("❌ Hotels API returned an error:", data.error);
      return [];
    }

    return Array.isArray(data?.hotels)
      ? data.hotels.map(hotel => ({
          code: hotel.HotelCode || "",
          name: hotel.HotelName || "",
        }))
      : [];
  } catch (error) {
    console.error("❌ Error fetching hotels:", error);
    return [];
  }
};

// ✅ THIS: fetchHotelAvailability
export const fetchHotelAvailability = async (payload) => {
  try {
    const res = await fetch("https://online.funforay.com/admin/api/hotels/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(payload),
    });

    // Get raw text to debug
    const text = await res.text();
    console.log("📥 Raw API Response:", text);

    let data;
    try {
      data = JSON.parse(text);
    } catch (err) {
      console.error("❌ Response is not JSON:", text);
      return null;
    }

    return data;
  } catch (error) {
    console.error("❌ Error fetching hotel availability:", error);
    return null;
  }
};









